/**
 * Age Calculator - UI interactivity only.
 * Scrolls to results after form submission. All calculations are server-side.
 */
(function () {
    'use strict';

    function init() {
        var results = document.getElementById('ac-results');
        if (results) {
            results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
